import config from 'config/config'
import { I18n } from 'lib/i18n'
import { del, get, post, put } from 'lib/utilities'
import { push } from 'react-router-redux'
import { toast } from 'react-toastify'
import { loadShopProducts } from 'redux/product'

export const LOAD = 'categories/LOAD'
export const LOAD_DONE = 'categories/LOAD_DONE'
export const LOAD_FAILED = 'categories/LOAD_FAILED'

export const LOAD_PATH_LEAVES = 'categories/LOAD_PATH_LEAVES'
export const LOAD_PATH_LEAVES_DONE = 'categories/LOAD_PATH_LEAVES_DONE'
export const LOAD_PATH_LEAVES_FAILED = 'categories/LOAD_PATH_LEAVES_FAILED'

export const LOAD_PATHS = 'categories/LOAD_PATHS'
export const LOAD_PATHS_DONE = 'categories/LOAD_PATHS_DONE'
export const LOAD_PATHS_FAILED = 'categories/LOAD_PATHS_FAILED'

export const MOVE_NODE = 'categories/MOVE_NODE'
export const MOVE_NODE_FULFILLED = 'categories/MOVE_NODE_FULFILLED'
export const MOVE_NODE_FAILED = 'categories/MOVE_NODE_FAILED'

export const CREATE_CATEGORY = 'categories/CREATE_CATEGORY'
export const CREATE_CATEGORY_DONE = 'categories/CREATE_CATEGORY_DONE'
export const CREATE_CATEGORY_FAILED = 'categories/CREATE_CATEGORY_FAILED'

export const SAVE_CATEGORY = 'categories/SAVE_CATEGORY'
export const SAVE_CATEGORY_DONE = 'categories/SAVE_CATEGORY_DONE'
export const SAVE_CATEGORY_FAILED = 'categories/SAVE_CATEGORY_FAILED'

export const DELETE_CATEGORY = 'categories/DELETE_CATEGORY'
export const DELETE_CATEGORY_DONE = 'categories/DELETE_CATEGORY_DONE'
export const DELETE_CATEGORY_FAILED = 'categories/DELETE_CATEGORY_FAILED'

// action creators

export const loadProductCategories = () => ({ type: LOAD })
export const loadFulfilled = (categories) => ({ type: LOAD_DONE, categories })
export const loadFailed = () => ({ type: LOAD_FAILED })

export const loadPathLeaves = () => ({ type: LOAD_PATH_LEAVES })
export const loadPathLeavesFulfilled = (categoryPaths) => ({
  type: LOAD_PATH_LEAVES_DONE,
  pathLeaves: categoryPaths,
})
export const loadPathLeavesFailed = (errors) => ({
  type: LOAD_PATH_LEAVES_FAILED,
  errors,
})

export const loadPaths = () => ({ type: LOAD_PATHS })
export const loadPathsFulfilled = (paths) => ({ type: LOAD_PATHS_DONE, paths })
export const loadPathsFailed = (errors) => ({ type: LOAD_PATHS_FAILED, errors })

export const moveNode = (id, parentId, position) => ({
  type: MOVE_NODE,
  id,
  parentId,
  position,
})
export const moveNodeFulfilled = () => ({ type: MOVE_NODE_FULFILLED })
export const moveNodeFailed = (errors) => ({ type: MOVE_NODE_FAILED, errors })

export const createCategory = (newCategory) => ({
  type: CREATE_CATEGORY,
  newCategory,
})
export const createCategoryFulfilled = () => ({ type: CREATE_CATEGORY_DONE })
export const createCategoryFailed = () => ({ type: CREATE_CATEGORY_FAILED })

export const saveCategory = (category) => ({
  type: SAVE_CATEGORY,
  category: category,
})
export const saveCategoryFulfilled = () => ({ type: SAVE_CATEGORY_DONE })
export const saveCategoryFailed = () => ({ type: SAVE_CATEGORY_FAILED })

export const deleteCategory = (id) => ({ type: DELETE_CATEGORY, id })
export const deleteCategoryFulfilled = () => ({ type: DELETE_CATEGORY_DONE })
export const deleteCategoryFailed = () => ({ type: DELETE_CATEGORY_FAILED })

const initialState = {
  activeTreeNode: null,
  treeLoading: false,
  pathLeavesLoading: false,
  categoriesLoading: false,
  categories: [],
  pathLeaves: [],
  newCategory: null,
  newCategoryModalVisible: false,
}

// TODO: it seems we have an issue with categories vs. breadcrumbs. first ctageories are loaded and then replaced by breadcrumbs ...?
export const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD:
      return { ...state, categoriesLoading: true }
    case LOAD_DONE:
      return {
        ...state,
        categoriesLoading: false,
        categories: action.categories,
        categoriesLoadedAt: new Date().getTime(),
      }

    case LOAD_PATH_LEAVES:
      return { ...state, pathLeavesLoading: true }
    case LOAD_PATH_LEAVES_DONE:
      return {
        ...state,
        pathLeavesLoading: false,
        pathLeaves: action.pathLeaves,
      }
    case LOAD_PATH_LEAVES_FAILED:
      return { ...state, pathLeavesLoading: false }

    case LOAD_PATHS:
      return { ...state, pathsLoading: true }
    case LOAD_PATHS_DONE:
      return { ...state, pathsLoading: false, paths: action.paths }
    case LOAD_PATHS_FAILED:
      return { ...state, pathsLoading: false }

    case CREATE_CATEGORY:
      return { ...state, newCategory: action.newCategory }
    case CREATE_CATEGORY_DONE:
      return { ...state, categorySaved: true, newCategoryModalVisible: false }

    case SAVE_CATEGORY:
      return { ...state, modifiedCategory: action.category }
    case SAVE_CATEGORY_DONE:
      return {
        ...state,
        categorySaved: true,
        category: state.modifiedCategory,
        categorySavedAt: new Date().getTime(),
      }

    case DELETE_CATEGORY:
      return { ...state, deletingCategory: true }
    case DELETE_CATEGORY_DONE:
      return { ...state, deletingCategory: false }

    default:
      return state
  }
}

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD)
    .mergeMap((action) => get('/product_categories.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.categories/LOAD_CATEGORIES_FAILED'))
        return [loadFailed(result.body.errors)]
      }
    })

export const moveNodeEpic = (action$, store) =>
  action$
    .ofType(MOVE_NODE)
    .mergeMap((action) =>
      put('/product_categories/move.json', {
        movement: {
          id: action.id,
          parent_id: action.parentId,
          position: action.position,
        },
      })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [
          moveNodeFulfilled(),
          loadProductCategories(),
          loadPaths(),
          loadPathLeaves(),
        ]
      } else {
        toast.error(I18n.t('action.categories/MOVE_NODE_FAILED'))
        return [moveNodeFailed(result.body.errors)]
      }
    })

export const loadPathLeavesEpic = (action$, store) =>
  action$
    .ofType(LOAD_PATH_LEAVES)
    .mergeMap((action) => get('/product_categories/path_leaves.json'))
    .mergeMap((result) => {
      if (result.ok) {
        // TODO: add key to each entry to avid missing keys warnings
        return [loadPathLeavesFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.categories/LOAD_BREADCRUMBS_FAILED'))
        return [loadPathLeavesFailed(result.body.errors)]
      }
    })

export const loadPathsEpic = (action$, store) =>
  action$
    .ofType(LOAD_PATHS)
    .mergeMap((action) => get('/product_categories/paths.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadPathsFulfilled(result.body)]
      } else {
        toast.error(I18n.t('action.categories/LOAD_PATHS_FAILED'))
        return [loadPathsFailed(result.body.errors)]
      }
    })

export const createCategoryEpic = (action$, store) =>
  action$
    .ofType(CREATE_CATEGORY)
    .mergeMap((action) => {
      const category = action.newCategory
      const product_category = {
        title_de: category.title_de,
        title_fr: category.title_fr,
        parent_id: category.parent_id,
      }
      if (category.type === 'virtual')
        product_category.link_target_id = category.link_target_id

      return post('/product_categories.json', { product_category })
    })
    .mergeMap((result) => {
      if (result.ok) {
        return [
          loadProductCategories(),
          loadPathLeaves(),
          loadPaths(),
          createCategoryFulfilled(),
          loadShopProducts(),
        ]
      } else {
        toast.error(I18n.t('action.categories/CREATE_CATEGORY_FAILED'))
        return [createCategoryFailed(result.body.errors)]
      }
    })

export const deleteCategoryEpic = (action$, store) =>
  action$
    .ofType(DELETE_CATEGORY)
    .mergeMap((action) => del(`/product_categories/${action.id}.json`))
    .mergeMap((result) => {
      if (result.ok) {
        return [
          loadProductCategories(),
          loadPathLeaves(),
          loadPaths(),
          deleteCategoryFulfilled(),
          push(config.nodes.category),
          loadShopProducts(),
        ]
      } else {
        toast.error(I18n.t('action.categories/DELETE_CATEGORY_FAILED'))
        return [deleteCategoryFailed(result.body.errors)]
      }
    })

export const saveCategoryEpic = (action$, store) =>
  action$
    .ofType(SAVE_CATEGORY)
    .mergeMap((action) => {
      return put(`/product_categories/${action.category.id}.json`, {
        product_category: {
          visible: action.category.visible,
          title_de: action.category.title_de,
          title_fr: action.category.title_fr,
          description_de: action.category.description_de,
          description_fr: action.category.description_fr,
          meta_description_de: action.category.meta_description_de,
          meta_description_fr: action.category.meta_description_fr,
          thumbnail_id: action.category.thumbnailMediumId,
          header_image_id: action.category.headerMediumId,
          product_ids: action.category.productIds,
          property_filters: action.category.properties,
          link_target_id: action.category.link_target_id,
          parent_id: action.category.parent_id,
        },
      })
    })
    .mergeMap((result) => {
      if (result.ok) {
        toast.success(I18n.t('action.categories/SAVE_DONE'))
        return [
          saveCategoryFulfilled(),
          loadProductCategories(),
          loadPathLeaves(),
          loadPaths(),
          loadShopProducts(),
        ]
      } else {
        toast.error(I18n.t('action.categories/CREATE_CATEGORY_FAILED'))
        return [createCategoryFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/categories.js